import React from 'react'
import CardItem from './CardItem'
import './Cards.css';

function Cards() {
  return (
    <div className='cards'>
        <h1>PBS Information Systems</h1>
        <div className='cards__container'>
            <div className='cards__wrapper'>
                <ul className='cards__items'>
                    {/* {url = may token ? /homepage : /login } */}
                    <CardItem
                    src='images/2.jpg'
                    text= "Digital Audio Management System"
                    label ='DAMS'
                    path = 'http://localhost:3004/homepage'

                    />
                     <CardItem
                    src="images/3.jpg"
                    text= "News Information Management System"
                    label ='NIMS'
                    path ='http://localhost:3002/homepage'
                    />
                     <CardItem
                    src="images/4.jpg"
                    text= "Propert and Supply Inventory System"
                    label ='PSIS'
                    path ='http://pbspsims.rf.gd/login.php?fbclid=IwAR3BX3uoBew5QCenRQUYXDld0AJCkBAur9GmT0ITkdAne3PpIMCht7fg7_c'
                    />
                     <CardItem
                    src="images/1.jpg"
                    text= "Fleet Management System"
                    label ='FMS'
                    path ='http://bbsfms.rf.gd/login.php?fbclid=IwAR1gam7A3ot4vZ-h_OJ1SI8uxGnruiKcL__Nw1iRrtTSvnoa4JmENYxOktw'
                    />

                </ul>
            </div>
        </div>
    </div>
  )
}

export default Cards;